"use client";

import {
  Button,
  cn,
  HR,
  Icon,
  ModalContent,
  ModalHeader,
  PortalModal,
  usePortalContext,
} from "@cloai/uikit";
import { useTranslations } from "next-intl";
import { memo } from "react";

import { useDropzoneSettings } from "@/components/user-flow/utils/useDropzoneSettings";
import { useGTMContext, useUndressContext } from "@/providers";

import { STYLES } from "./styles";
import { GE } from ".constants/gtmEvents";
import { PORTALS } from ".constants/portals";

export const UploadPortal = memo(() => {
  const t = useTranslations("UserFlowModal");
  const b = useTranslations("HomePage");
  const { loading } = useUndressContext();
  const { openPortal, closePortal } = usePortalContext();
  const { sendGTM } = useGTMContext();

  const {
    maxFilesPhoto,
    getRootPhotoProps,
    getInputPhotoProps,
    isDragPhotoActive,
  } = useDropzoneSettings();

  const onUploadUrl = () => {
    sendGTM({ event: GE.FLOW_START_CLICK_UPLOAD_URL });
    closePortal();
    openPortal(PORTALS.ATTACH_PHOTO_BY_URL);
  };

  return (
    <PortalModal
      portalId={PORTALS.USER_FLOW_UPLOAD}
      style={STYLES.portal.variants.medium}
    >
      <ModalHeader>{t("titles.uploadPhotos")}</ModalHeader>

      <ModalContent>
        <div
          className={cn(
            STYLES.dropzone.base,
            isDragPhotoActive && STYLES.dropzone.states.draging,
            loading && STYLES.dropzone.states.loading,
          )}
          {...getRootPhotoProps({})}
        >
          <input {...getInputPhotoProps()} />

          <Icon icon="attach_file" size={10} />

          <span className={STYLES.dropzone.text}>
            {t.rich("dropzoneText", {
              count: maxFilesPhoto,
              br: () => <br />,
              orange: (text) => <span className="text-primary">{text}</span>,
            })}
          </span>
        </div>

        <HR text={t("or")} />

        <Button
          startContent={<Icon icon="add_link" />}
          wide
          centerText
          onClick={onUploadUrl}
          loading={loading}
        >
          {b("photoByURL")}
        </Button>
      </ModalContent>
    </PortalModal>
  );
});

UploadPortal.displayName = "UploadPortal";
